module.exports = __webpack_public_path__ + "common/sidebar/icon-credit-card-9fec29cef1a00b396755d7e89c17c57f.svg";